import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthorizationModule } from '@wilson/authorization';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import { ActivityDeviationStatus, GeoLocation } from '@wilson/interfaces';
import { LabelsModule } from '@wilson/labels';
import {
  LocalizedDateFormatPipe,
  LocalizedTimeFormatPipe,
} from '@wilson/localization';
import { PriorityModule } from '@wilson/non-domain-specific/priority';
import { ShiftCoreModule } from '@wilson/shift/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTagModule } from 'ng-zorro-antd/tag';

@Component({
  selector: 'wilson-tooltip-shift-schedule-details',
  templateUrl: './tooltip-shift-schedule-details.component.html',
  styleUrls: ['./tooltip-shift-schedule-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    NzTagModule,
    NzDividerModule,
    TranslatePipe,
    ShiftCoreModule,
    PriorityModule,
    FeatureFlagsModule,
    LabelsModule,
    AuthorizationModule,
    LocalizedDateFormatPipe,
    LocalizedTimeFormatPipe,
  ],
})
export class TooltipShiftScheduleDetailsComponent {
  protected ActivityDeviationStatus: typeof ActivityDeviationStatus =
    ActivityDeviationStatus;

  @Input({ required: true }) headerText = '';
  @Input({ required: true }) plannedDateTime = '';
  @Input({ required: true }) plannedLocation:
    | Pick<GeoLocation, 'name' | 'locationCode'>
    | null
    | undefined = null;
  @Input() accurateDateTime: string | undefined = undefined;
  @Input() reportedLocation?: Pick<
    GeoLocation,
    'name' | 'locationCode'
  > | null = null;
  @Input({ required: true }) timeType: ActivityDeviationStatus | null = null;
  @Input() timeDifference?: number | null = null;
}
